module.exports = __webpack_public_path__ + "img/benedito_abbud.a9d4146a.jpg";